import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft, FiUsers } from 'react-icons/fi';

const C = {
  rose: '#e3425c', roseLight: 'rgba(227,66,92,0.08)', roseDeep: '#c94d5c',
  gold: '#d4a853', goldLight: 'rgba(212,168,83,0.12)', goldDark: '#b8923e',
  dark: '#1c1c1e', darkLight: '#3a3a3c', cream: '#f7f7f8', creamDark: '#ebebed',
  white: '#ffffff', gray: '#8e8e93', grayLight: '#aeaeb2',
};

const TEAM = [
  {
    name: 'Boitumelo Mosaka',
    role: 'Founder & Innovation Lead',
    img: '/Boitumelo_Mosaka.png',
    bio: 'Responsible for concept development, product vision, user experience design, and ecosystem partnerships. Boitumelo is the driving force behind Grand Gather Registry, ensuring the platform empowers hosts across South Africa.'
  },
  {
    name: 'Bongani Melembe',
    role: 'Head of Development',
    img: '/Bongani_pic-removebg-preview.png',
    bio: 'Responsible for the technical development of the platform, including system architecture, backend development, platform infrastructure and integration of digital technologies required for the Grand Gather Registry ecosystem.'
  },
  {
    name: 'Siyanda Gazu',
    role: 'Project Manager',
    img: '/Siyanda_Gazu2.png',
    bio: 'Responsible for project coordination, development timelines, and ensuring the successful delivery of the platform. Siyanda brings valuable experience in technology project management and execution.'
  },
  {
    name: 'Thabiso Mabiletja',
    role: 'Front-End Developer',
    img: '/Thabiso_Mabiletja.png',
    bio: 'Responsible for developing the user interface and front-end functionality of the platform, ensuring the platform is user-friendly, responsive and accessible across web and mobile devices.'
  }
];

export default function Team() {
  return (
    <div style={{ minHeight: '100vh', background: C.cream, fontFamily: 'Inter, -apple-system, sans-serif' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=Inter:wght@400;500;600;700&display=swap');
        * { box-sizing: border-box; }
      `}</style>

      {/* Nav */}
      <nav style={{ position: 'sticky', top: 0, zIndex: 100, background: 'rgba(255,255,255,0.97)', backdropFilter: 'blur(20px)', borderBottom: `1px solid ${C.creamDark}`, padding: '14px 0' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link to='/' style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none', color: C.dark }}>
            <FiArrowLeft size={16} />
            <img src="/ggr-logo-deck.png" alt='GGR' style={{ height: '50px', width: 'auto' }} />
          </Link>
          <Link to='/register' style={{ padding: '10px 22px', borderRadius: '8px', background: C.rose, color: C.white, textDecoration: 'none', fontSize: '13px', fontWeight: 600, fontFamily: 'Inter, sans-serif' }}>
            Get Started
          </Link>
        </div>
      </nav>

      {/* Hero */}
      <section style={{ background: `linear-gradient(135deg, ${C.rose} 0%, ${C.roseDeep} 100%)`, padding: '80px 0', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: '-30%', right: '-10%', width: '600px', height: '600px', borderRadius: '50%', background: 'rgba(255,255,255,0.04)' }} />
          <div style={{ position: 'absolute', bottom: '-20%', left: '-5%', width: '400px', height: '400px', borderRadius: '50%', background: 'rgba(212,168,83,0.1)' }} />
        </div>
        <div style={{ maxWidth: '720px', margin: '0 auto', padding: '0 28px', textAlign: 'center', position: 'relative', zIndex: 1 }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '6px 16px', borderRadius: '20px', background: 'rgba(255,255,255,0.15)', color: C.white, fontSize: '11px', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '16px' }}>
            <FiUsers size={12} /> Our Team
          </div>
          <h1 style={{ fontFamily: 'Playfair Display, Georgia, serif', fontSize: 'clamp(32px, 5vw, 52px)', fontWeight: 700, color: C.white, lineHeight: 1.15, marginBottom: '16px' }}>
            Meet the Team
          </h1>
          <p style={{ fontSize: '17px', color: 'rgba(255,255,255,0.85)', lineHeight: 1.7 }}>
            The passionate people behind Grand Gather Registry
          </p>
        </div>
      </section>

      {/* Team grid */}
      <section style={{ padding: '80px 0' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 28px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '28px' }}>
            {TEAM.map((member, i) => (
              <div key={i} style={{
                background: C.white, borderRadius: '18px', padding: '40px 26px', textAlign: 'center',
                border: `1px solid ${C.creamDark}`, transition: 'all 0.3s'
              }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.1)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = ''; }}
              >
                <div style={{
                  width: '120px', height: '120px', borderRadius: '50%', overflow: 'hidden',
                  margin: '0 auto 18px',
                  border: `3px solid ${C.rose}20`,
                  boxShadow: `0 4px 16px ${C.rose}15`
                }}>
                  <img src={member.img} alt={`${member.name} — ${member.role}`}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center 20%' }} />
                </div>
                <h3 style={{ fontSize: '18px', fontWeight: 700, color: C.dark, marginBottom: '4px' }}>{member.name}</h3>
                <div style={{ fontSize: '13px', fontWeight: 600, color: C.rose, marginBottom: '14px' }}>{member.role}</div>
                <p style={{ fontSize: '13.5px', color: C.gray, lineHeight: 1.7 }}>{member.bio}</p>
              </div>
            ))}
          </div>

          <div style={{ textAlign: 'center', marginTop: '56px' }}>
            <Link to='/about' style={{ fontSize: '14px', color: C.rose, textDecoration: 'none', fontWeight: 600 }}>
              Learn more about our story →
            </Link>
          </div>
        </div>
      </section>

      {/* Footer strip */}
      <footer style={{ background: C.dark, padding: '28px 0', textAlign: 'center' }}>
        <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.4)' }}>
          © {new Date().getFullYear()} Grand Gather Registry — Seamless Events, Thoughtful Gifting
        </div>
      </footer>
    </div>
  );
}
